module.exports = __webpack_public_path__ + "img/image-1.ee406179.jpg";